/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { getCivilStatusLabel } from "../../ClientPage/service/ClientPageServices"
import Bloc from "./Bloc"
import Field from "./Field"
import React from "react"

export default function SignatoryBloc({
  configuration,
  values,
  tunnelData,
  index
}) {
  const { signatory } = configuration

  return (
    <Bloc hide={!signatory} name={"Signatory"} data={index + 1}>
      <Field
        hide={!signatory?.includes("title")}
        name={"Title"}
        value={getCivilStatusLabel(tunnelData, values.title)}
      />
      <Field
        hide={!signatory?.includes("name")}
        name={"Signatory name"}
        value={values.name}
      />
      <Field
        hide={!signatory?.includes("firstName")}
        name={"Signatory first name"}
        value={values.firstName}
      />
      <Field
        hide={!signatory?.includes("signatoryBirthdate")}
        name={"Signatory birthdate"}
        value={values.signatoryBirthdate}
      />
      <Field
        hide={!signatory?.includes("email")}
        name={"Signatory email"}
        value={values.email}
      />
      <Field
        hide={!signatory?.includes("phoneNumber")}
        name={"Signatory mobile phone"}
        value={"+".concat(values.phoneNumber)}
      />
    </Bloc>
  )
}
